let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g8MHs")).then(() => parcelRequire('9bnl0'));